export default "__VITE_ASSET__BLMVkzeh__"